import Layout from '@/layouts/EmptyLayout'
export default [{
    path: '/table',
    name: 'table',
    meta: {
      layout: 'main'
    },
  component: () => import('@/views/table/index')
    
  }]
